import { Routes } from '@angular/router'
import { canActivate, canActivateChild } from './FuseQ/fuseqGuard.fn'
import { maintenanceBlockGuard } from './_shared/maintenance/maintenance.service'
import { DefaultLayoutComponent } from './containers'
import { P404Component } from './views/error/404.component'
import { P500Component } from './views/error/500.component'
import { LoginComponent } from './views/login/login.component'
import { SdwanMonitorComponent } from './views/embedded/sdwan-monitor.component'

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: '404',
    component: P404Component,
    data: { title: 'Page 404' }
  },
  {
    path: '500',
    component: P500Component,
    data: { title: 'Page 500' }
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./views/maintenance/maintenance.component').then(m => m.MaintenancePageComponent),
    data: { title: 'Maintenance' }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login Page' }
  },
  {
    path: 'sdwanmonitor',
    component: SdwanMonitorComponent,
    canActivate: [canActivate],
    data: { title: 'SDWAN Monitor' }
  },
  {
    path: 'NRDStatus',
    loadComponent: () => import('./views/awpNRD/NRD-Status-ext/NRDStatus').then(m => m.NRDStatusComponent),
    data: { title: 'NRD Status' }
  },
  {
    path: 'nrd',
    loadComponent: () => import('./views/awpNRD/NRD-Status-ext/NRDStatus').then(m => m.NRDStatusComponent),
    data: { title: 'NRD Status' }
  },
  {
    path: 'switch',
    loadComponent: () => import('./views/awpDashboard/switch_ext/switch').then(m => m.SwitchComponent),
    data: { title: 'Switch' }
  },
  {
    path: 'rtu',
    loadComponent: () => import('./views/awpDashboard/rtu_ext/rtu').then(m => m.RTUComponent),
    data: { title: 'RTU' }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [canActivate, maintenanceBlockGuard],
    canActivateChild: [canActivateChild],
    data: { title: 'Home' },
    children: [
      {
        path: 'systemMonitor',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/systemMonitor/systemMonitor.routes').then(r => r.routes)
      },
      {
        path: 'admin',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/admin/admin.routes').then(r => r.routes)
      },
      {
        path: 'profiling',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/profiling/profiling.routes').then(r => r.routes)
      },
      {
        path: 'raker',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/raker/raker.routes').then(r => r.routes)
      },
      {
        path: 'perimetro-awp',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/perimetroAWP/perimetroAWP.routes').then(r => r.routes)
      },
      {
        path: 'sdwan-network',
        canActivateChild: [canActivateChild],
        loadComponent: () => import('./views/awp/sdwan-network/sdwan-network').then(m => m.SdwanNetworkComponent),
        data: { title: 'SDWAN Network' }
      },
      {
        path: 'mediation-awp',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/perimetroAWP_mediation/mediation.routes').then(r => r.routes)
      },
      {
        path: 'speedTest-awp',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/speedTestAWP/speedTestAWP.routes').then(r => r.routes)
      },
      {
        path: 'starlink',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/starlink/starlink.routes').then(r => r.routes)
      },
      {
        path: 'customDashboard',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/customDashboard/customDashboard.routes').then(r => r.routes)
      },
      {
        path: 'awpDashboardCisco/wf',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awpWorkflow/awp.routes').then(r => r.routes)
      },
      {
        path: 'awpDashboard/wf',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awpWorkflow/awp.routes').then(r => r.routes)
      },

      {
        path: 'rtu-dashboard',
        canActivateChild: [canActivateChild],
        loadComponent: () => import('./views/awpDashboard/rtu_ext/rtu-dashboard/rtu-dashboard').then(m => m.RtuDashboardComponent),
        data: { title: 'Dashboard RTU' }
      },
      {
        path: 'awpDashboard',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awpDashboard/dashboard.routes').then(r => r.routes)
      },
      {
        path: 'awpDashboardCisco',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awpDashboardCisco/dashboard.routes').then(r => r.routes)
      },
      {
        path: 'support',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/support/support.routes').then(r => r.routes)
      },
      {
        path: '',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awpWorkflow/awp.routes').then(r => r.routes)
      },
      {
        path: 'awp',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awp/awp.routes').then(r => r.routes)
      },
      {
        path: 'NRD',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/awpNRD/NRD.routes').then(r => r.routes)
      },
      {
        path: 'voip',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/voipWorkflow/voip.routes').then(r => r.routes)
      },
      {
        path: 'voipfastweb',
        canActivateChild: [canActivateChild],
        loadChildren: () => import('./views/voipWorkflow/voip.routes').then(r => r.routes)
      }
    ]
  },
  { path: '**', redirectTo: 'login' }
]
